"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.end.failed': 'Impossibile terminare la conversazione',
};
